import React, { useState } from 'react';
import { Commune } from '../types/Commune';
import './CommuneSearch.css';

interface CommuneSearchProps {
  communes: Commune[];
  onCommuneSelect: (communeId: string) => void;
  loading: boolean;
}

const CommuneSearch: React.FC<CommuneSearchProps> = ({ communes, onCommuneSelect, loading }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);

  const filteredCommunes = communes.filter(commune =>
    commune.id.includes(searchTerm) || 
    commune.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
    commune.ville.toLowerCase().includes(searchTerm.toLowerCase())
  ).slice(0, 10); // Limiter à 10 suggestions

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    setShowSuggestions(value.length > 0);
  };

  const handleCommuneClick = (commune: Commune) => {
    setSearchTerm(`${commune.id} - ${commune.nom}`);
    setShowSuggestions(false);
    onCommuneSelect(commune.id);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      const commune = communes.find(c => c.id === searchTerm.trim());
      if (commune) {
        onCommuneSelect(commune.id);
      }
    }
  };

  return (
    <div className="commune-search">
      <form onSubmit={handleSubmit} className="search-form">
        <div className="search-input-container">
          <input
            type="text"
            value={searchTerm}
            onChange={handleInputChange}
            placeholder="Entrez l'ID de la commune (ex: 1000) ou son nom..."
            className="search-input"
            disabled={loading}
          />
          <button type="submit" className="search-button" disabled={loading}>
            {loading ? 'Chargement...' : 'Rechercher'}
          </button>
        </div>
      </form>

      {showSuggestions && filteredCommunes.length > 0 && (
        <div className="suggestions">
          {filteredCommunes.map(commune => (
            <div
              key={commune.id}
              className="suggestion-item"
              onClick={() => handleCommuneClick(commune)}
            >
              <span className="commune-id">{commune.id}</span>
              <div className="commune-info">
                <span className="commune-name">{commune.nom}</span>
                <span className="commune-ville">{commune.ville} ({commune.codePostal})</span>
              </div>
              <span className="commune-population">
                {commune.nombreHabitants.toLocaleString()} hab.
              </span>
            </div>
          ))}
        </div>
      )}

      {showSuggestions && searchTerm && filteredCommunes.length === 0 && (
        <div className="no-results">
          Aucune commune trouvée pour "{searchTerm}"
        </div>
      )}
    </div>
  );
};

export default CommuneSearch; 